<template>
  <div>
   <paymentsAudit/>
  </div>
</template>

<script>
import PaymentsAudit from '../../../components/tax/payments/audit/paymentsAudit.vue';

export default {
  name: 'auditing',
  components: {
    PaymentsAudit,
  },
};
</script>
